export default "__VITE_ASSET__CW4FfNm9__"